import { Link } from 'react-router-dom';
import classes from './BaseLink.module.css';

interface IBaseLinkProps {
    children: string;
    to: string;
    button?: boolean;
    size: 's' | 'm';
    extraClass?: string;
    title?: string;
    newTab?: boolean;
}
const BaseLink: React.FC<IBaseLinkProps> = ({ children, to, button, size = 'm', extraClass, title, newTab = false }) => {
    const composedClassName = `
    ${classes.link}
    ${button ? classes.button : ''}
    ${classes[size]}
    ${extraClass ? (classes[extraClass] ?? extraClass) : ''}
  `.trim();
    return (
        <Link
            title={title ? title : ''}
            to={to}
            className={composedClassName}
            target={newTab ? '_blank' : undefined}
            rel={newTab ? 'noopener noreferrer' : undefined}
        >
            {children}
        </Link>
    );
};

export default BaseLink;
